import {Button, Modal} from '@logistics-frontend/blocks'
import React, {type ReactElement} from 'react'

import type * as t from 'src/api/cargo-c2c/types'

import * as classes from './CancelModal.classes'
import type {Message, MessageButton} from './utils'

type Props = {
  message: Message
  onClose: VoidFunction
  onCancel(type: t.CancelType, revision: number): void
}

export function CancelModal(props: Props): ReactElement {
  const {message, onClose, onCancel} = props

  function pressHandler(button: MessageButton) {
    return function _pressHandler() {
      if (button.type === 'free_cancel') {
        onCancel('free', message.revision)
      }

      if (button.type === 'paid_cancel') {
        onCancel('paid', message.revision)
      }

      onClose()
    }
  }

  return (
    <Modal className={classes.modal} mx="m" onClose={onClose} opened={message.opened}>
      <Modal.Header title={message.title} />
      {message.body && <Modal.Body>{message.body}</Modal.Body>}
      <Modal.Footer>
        <Modal.Footer.Controls>
          {message.buttons.map(button => {
            return (
              <Button key={button.type} onPress={pressHandler(button)} size="l" variant={button.variant}>
                {button.title}
              </Button>
            )
          })}
        </Modal.Footer.Controls>
      </Modal.Footer>
    </Modal>
  )
}
